import { createContext } from 'react';
import { AssetParam } from "./tree_view/TreeViewAssets";
import { ButtonConfig } from "./commandButtonsConfig";
import { Application, Sequence, MachinelogicLibrary } from '@vse/machinelogic/types';
import { LeftPaneSelectedSection, LeftPaneSelectedTab } from "../../../constants";

interface Path {
  /**
   * A URL pathname, beginning with a /.
   */
  pathname: string;
  /**
   * A URL search string, beginning with a ?.
   */
  search: string;
  /**
   * A URL fragment identifier, beginning with a #.
   */
  hash: string;
}
type To = string | Partial<Path>;

export type Navigate = (to: To) => void;

export interface ILeftPaneContext {
  isApplicationInEditMode: boolean;
  setIsApplicationInEditMode: (isApplicationInEditMode: boolean) => void;
  selectedTab: LeftPaneSelectedTab;
  setSelectedTab: (selectedTab: LeftPaneSelectedTab) => void;
  selectedSection: LeftPaneSelectedSection
  setSelectedSection: (selectedSection: LeftPaneSelectedSection) => void;
  library: MachinelogicLibrary;
  commandButtonsConfig: ButtonConfig[];
  pendantNavigate: Navigate;
  applicationErrorsWidget: (app: Application, pendantNavigate: Navigate) => any;
  openSequence: (library: MachinelogicLibrary, application: Application, sequence: Sequence) => void;
  invalidInstructionUuids: string[];
  showConfirmationModal: (title: string, message: string, onConfirm: () => void) => void;
  openDocument: (application: Application, focusedParamType?: string, param?: AssetParam) => void;
  isRunning: boolean;
  navigateToReferencedSequence: (sequenceName: string) => void;
}

export const LeftPaneContext = createContext<ILeftPaneContext>({} as ILeftPaneContext);
